	
function bannerView(bannerId) {
	$.ajax({
		type: "GET",
		url: cyclone3.domain + '/json/' + cyclone3.lng + '/a900_view',
		data: {
			'id' : bannerId
		},
		xhrFields: {
			withCredentials: true
		},
	});
}